import "./Css/app.css";
import "./Css/snack.css";
import "./Css/menu.css";

import "moment/locale/pl";
import moment from "moment";
import { NumberInput, TextInput, Button, Select, ModalWindow, Root, MultilineInput, DestroyingPatternContentSwitcher, HashRef, Div, Image, Span, Switch } from "@tblabs/truffle";
import { JobOfferConverter } from "./Models/JobOfferConverter";
import { ApplyFormConverter } from "./Models/ApplyFormConverter";
import { AdminOfferEditPage } from "./Pages/AdminOfferEditPage";
import { AdminMainPage } from "./Pages/AdminMainPage";
import { Router } from "./Services/Router";
import { ObjectDataset, IStorageUser, } from "@tblabs/storage";
import { OnlineStorage } from "@tblabs/storage";
import { JobOffer } from "./Models/JobOffer";
import { ApplyForm } from "./Models/ApplyForm";
import { LoginPage } from "./Pages/LoginPage";
import { RecruitJobsListView } from "./Pages/RecruitJobsListView";
import { LoginFormLogic } from "./Services/Auth/LoginFormLogic";
import { OfferPreview } from "./Pages/OfferPreview";
import { OfferApplyPage } from "./Pages/OfferApplyPage";
import { AdminApplyViewPage } from "./Pages/AdminApplyViewPage";
import { UserSection } from "./Components/UserSection";
import { OffersRepo } from "./Services/OffersRepo";
import { ApplysRepo } from "./Services/ApplysRepo";
import { Env } from "./Services/Env";
import { EnvDetector } from "./Services/EnvDetector";

moment?.locale('pl');

NumberInput.DefaultCssClasses = "uk-input uk-form-width-small";
TextInput.DefaultCssClasses = "uk-input";
Button.DefaultCssClasses = "uk-button uk-button-default";
Select.DefaultCssClasses = "uk-select";
ModalWindow.DefaultCssClasses = "tf-modal-window";
ModalWindow.Hook = Root.Hook;
MultilineInput.DefaultCssClasses = "uk-textarea";

(async () =>
{
    const root = new Root().Class("root");

    const hash = new HashRef();
    const _router = new Router(hash); 
    
    const _envDetector = new EnvDetector();
    const storageUrl = new Switch<Env, string>(_envDetector.Env)
        .Case(Env.Local, () => 'http://localhost/storageV5/src/')
        .Case(Env.Stage, () => 'https://stage.storage.specteam.pl/v5/')
        .Case(Env.Prod, () => 'https://storage.specteam.pl/v5/')
        .Default(() => 'https://storage.specteam.pl/v5/')
        .Execute() || "";

    const _storage = new OnlineStorage(storageUrl, "Recruit");
    const _offersConverter = new JobOfferConverter();
    const _applysConverter = new ApplyFormConverter();
    const _offersRepo = new ObjectDataset<JobOffer>(_storage, "Offers", _offersConverter);
    const _applysRepo = new ObjectDataset<ApplyForm>(_storage, "Applys", _applysConverter);
    const _offers = new OffersRepo(_offersRepo);
    const _applys = new ApplysRepo(_applysRepo);
    const _loginLogic = new LoginFormLogic(_storage)
        .OnLogin((user: IStorageUser, autologin: boolean) =>
        {
            if (!autologin)
                _router.GoToMainPage();
        })
        .OnLogout(() =>
        {
            _loginLogic.ClearLoginInfo();
            _router.GoToJobsListPage();
        })

    await _loginLogic.TryAutoLogin();

    const content = new DestroyingPatternContentSwitcher(hash)
        .AddContent("jobs", () => new RecruitJobsListView(_offers, _router))
        .AddContent("job/:id", ({ id }) => new OfferPreview(_offers, _router, id))
        .AddContent("job/:id/apply", ({ id }) => new OfferApplyPage(_offers, _applys, id))
        .AddContent("login", () => new LoginPage(_loginLogic))
        .AddContent("admin/main", () => new AdminMainPage(_offers, _applys, _router))
        .AddContent("admin/offer/:id/edit", ({ id }) => new AdminOfferEditPage(_offers, id))
        .AddContent("admin/apply/:id/view", ({ id }) => new AdminApplyViewPage(_applys, id))
        .AddDefaultContent(() => new RecruitJobsListView(_offers, _router))
        .Refresh()

    root.Append(
        new Div("header").Append(
            new Div("header-left").Append(
                new Image("https://photos.specteam.pl/pic/specteam/f66ac36c-2766-47a7-a2ac-a1069f504fea.original.png").Height(52).CursorPointer()
                    .OnClick(() => window.location.hash = ""),
                new Span("Oferty pracy specTeam").Color("#fdfdfd").CursorPointer()
                    .OnClick(() => window.location.hash = ""),
            ),
            new Div("header-right").Append(
                new UserSection(_storage, _router),
            ),
        ),
        content,
    )
})()
